const MAX_NUMBER_OF_QUESTIONS = 30;
const QUESTIONS_PER_STEP = 5;

export { MAX_NUMBER_OF_QUESTIONS, QUESTIONS_PER_STEP };
